import React from "react";

const Logo = ({ logoImageUrl, logoImageAltText }) =>
  logoImageUrl ? (
    <div
      style={{
        width: "135px",
        minHeight: "100px",
        marginBottom: "10px"
      }}
      tabIndex={0}
    >
      <img
        alt={logoImageAltText}
        src={logoImageUrl}
        style={{
          maxWidth: "100%"
        }}
      />
    </div>
  ) : null;

export default Logo;
